// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"TimelineDeliverablesModal_modalContent__2Vss_","mainContent":"TimelineDeliverablesModal_mainContent__2FO5Q","actions":"TimelineDeliverablesModal_actions__2Ov_5"};